import { downgradeInjectable } from '@angular/upgrade/static';

import { ApiService } from '../../../../app/shared/api.service';
import { UtilitiesService } from '../../../../app/shared/utilities.service';

angular
  .module('GlobalControllers', ['duScroll', 'angularMoment'])

  //config for /supports
  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider

        .when('/login', {
          templateUrl: '/ng1/www/modules/global/login/html/login.html',
          controller: 'LoginCtrl'
        })

        .when('/sso/:loginProvider', {
          templateUrl: '/ng1/www/modules/global/login/html/login.html',
          controller: 'LoginCtrl'
        })

        .when('/register', {
          templateUrl: '/ng1/www/modules/global/login/html/login.html',
          controller: 'LoginCtrl'
        })

        .when('/activation', {
          templateUrl: '/ng1/www/modules/global/login/html/login.html',
          controller: 'LoginCtrl'
        })

        .when('/password/reset', {
          templateUrl: '/ng1/www/modules/global/password/html/reset.html',
          controller: 'PasswordResetCtrl'
        })

        .when('/password/reset_validation', {
          templateUrl:
            '/ng1/www/modules/global/password/html/reset_validation.html',
          controller: 'PasswordResetValidationCtrl'
        })

        .when('/account', {
          templateUrl: '/ng1/www/modules/global/account/html/page.html',
          controller: 'AccountCtrl'
        })

        .when('/payment/form', {
          templateUrl: '/ng1/www/modules/global/payment/html/to_pay.html',
          controller: 'PaymentCtrl'
        })

        /*
      .when('/contact', {
        templateUrl: '/ng1/www/modules/global/contact/html/contact.html',
        controller: 'NotContactCtrl'
      })
      */

        .when('/salaries', {
          templateUrl: '/ng1/www/modules/global/others/html/salaries.html',
          controller: 'NotSalariesCtrl'
        })

        .when('/cpf-mon-compte-compte-formation', {
          templateUrl:
            '/ng1/www/modules/global/others/html/lerobert-home2.html',
          controller: 'NotSalariesCtrl'
        })

        .when('/organismes-de-formation', {
          templateUrl: '/ng1/www/modules/global/others/html/salaries.html',
          controller: 'NotSalariesCtrl'
        })

        .when('/etudiants', {
          templateUrl: '/ng1/www/modules/global/others/html/salaries.html',
          controller: 'NotSalariesCtrl'
        })

        .when('/pricing', {
          templateUrl: '/ng1/www/modules/global/payment/html/pricing.html',
          controller: 'NotPricingCtrl'
        })

        .when('/terms', {
          templateUrl: '/ng1/www/modules/global/others/html/terms.html',
          controller: 'TermsCtrl'
        })

        .when('/cgv', {
          templateUrl: '/ng1/www/modules/global/others/html/cgv.html',
          controller: 'CgvCtrl'
        })

        .when('/legals', {
          templateUrl: '/ng1/www/modules/global/others/html/legals.html',
          controller: 'LegalsCtrl'
        })

        .when('/nos-offres', {
          templateUrl: '/ng1/www/modules/global/others/html/offers.html',
          controller: 'OffersCtrl'
        })

        .when('/contact', {
          templateUrl: '/ng1/www/modules/global/others/html/contact.html',
          controller: 'ContactCtrl'
        })

        .when('/contact/universite', {
          templateUrl: '/ng1/www/modules/global/others/html/contact.html',
          controller: 'ContactCtrl'
        })

        .when('/contact/organisme-formation', {
          templateUrl: '/ng1/www/modules/global/others/html/contact.html',
          controller: 'ContactCtrl'
        })

        .when('/contact/entreprise', {
          templateUrl: '/ng1/www/modules/global/others/html/contact.html',
          controller: 'ContactCtrl'
        })

        .when('/newsletter', {
          templateUrl: '/ng1/www/modules/global/others/html/newsletter.html',
          controller: 'ContactCtrl'
        })

        .when('/credits', {
          templateUrl: '/ng1/www/modules/global/others/html/credits.html',
          controller: 'AboutCtrl'
        });
    }
  ])
  .run([
    'nbModules',
    'EXAM',
    function(nbModules, EXAM) {
      if (EXAM === 'delf') {
        // console.log('delf scope', $scope);
        nbModules.addModules(4);
        /*
        if (
          $scope.main.me.profile.is_manager &&
          !$scope.main.me.profile.is_guest
        ) {
          // for insitutional manager
        } else {
          nbModules.addModules(4);
        }
        */
      } else {
        nbModules.addModules(3);
      }
    }
  ])
  .run([
    'secondNavbar',
    'exam',
    'EXAM',
    function(secondNavbar, exam, EXAM) {
      secondNavbar.addModules('Accueil', '/', 0, 'navbar.home');
      if (exam.examData.langForExercises === 'fr') {
        secondNavbar.addModules(
          'Entraînement',
          '/entrainement',
          1,
          'navbar.training'
        );
        if (EXAM === 'lerobert') {
          secondNavbar.addModules('Tests', '/examen', 2);
        } else {
          secondNavbar.addModules('Examen', '/exam', 2, 'navbar.exam');
        }
      } else {
        secondNavbar.addModules(
          'Entraînement',
          '/training',
          1,
          'navbar.training'
        );
        secondNavbar.addModules('Examen', '/exam', 2, 'navbar.exam');
      }

      if (EXAM === 'delf') {
        secondNavbar.addModules(
          'Correction',
          '/correction',
          5,
          'navbar.correction'
        );
      }
    }
  ])
  .run([
    '$rootScope',
    '$document',
    function($rootScope, $document) {
      $rootScope.$on('$routeChangeSuccess', function(
        event,
        currentRoute,
        previousRoute
      ) {
        $document[0].getElementById(
          'scrollreveal-container'
        ).scrollTop = $document[0].documentElement.scrollTop = 0;
      });
    }
  ])

  .factory('ApiService', downgradeInjectable(ApiService))
  .factory('UtilitiesService', downgradeInjectable(UtilitiesService));
